import { BASE_INPUT_DEFAULT_DISABLE, BASE_INPUT_DEFAULT_MODE, BASE_INPUT_DEFAULT_ROLE, BASE_INPUT_DEFAULT_SIZE } from '../../common/BaseInput/BaseInput.constants';
// Constants.
// -----------------------------------------------------------------------------
/** Default disabled. */
export const TEXT_FIELD_DEFAULT_DISABLED = BASE_INPUT_DEFAULT_DISABLE;
/** Default mode. */
export const TEXT_FIELD_DEFAULT_MODE = BASE_INPUT_DEFAULT_MODE;
/** Default size. */
export const TEXT_FIELD_DEFAULT_SIZE = BASE_INPUT_DEFAULT_SIZE;
/** Default type. */
export const TEXT_FIELD_DEFAULT_TYPE = 'text';
/** Default role. */
export const TEXT_FIELD_DEFAULT_ROLE = BASE_INPUT_DEFAULT_ROLE;
//# sourceMappingURL=TextField.constants.js.map